import { render } from "./GeneralButton.vue?vue&type=template&id=6a495e14"
import script from "./GeneralButton.vue?vue&type=script&lang=js"
export * from "./GeneralButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__